import { toRefs, ref, computed, watch, nextTick } from 'vue';
import tinycolor from 'tinycolor2';
import uniqueId from 'lodash/uniqueId';
import ProfileCloseBtn from './component-lib.esm3.js';
import { timeout } from '../../utils/component-lib.esm.js';
import { useTheme } from '../../compositions/component-lib.esm3.js';
import { useResizeObserver } from '../../compositions/component-lib.esm7.js';

//
var script = {
  components: {
    ProfileCloseBtn
  },
  props: {
    isOpen: Boolean
  },
  setup(props) {
    const {
      isOpen
    } = toRefs(props);
    const contentId = ref(uniqueId('expand-'));
    const theme = useTheme();
    const container = ref(null);
    const content = ref(null);
    const dimensions = ref(null);
    const activator = ref(null);
    const btnHeight = ref(null);
    const wrapperHeight = ref(null);
    const wrapperOverflow = ref(null);
    useResizeObserver(container, entries => {
      entries.forEach(entry => {
        dimensions.value = {
          height: entry.contentRect.height,
          width: entry.contentRect.width
        };
      });
    });
    useResizeObserver(content, () => {
      handleResize();
    });
    const classes = computed(() => {
      return {
        'v-btn-expand--is-open': isOpen.value
      };
    });
    const styles = computed(() => {
      // Make video container background a solid color
      let bgColor = theme.value.profile.btnBgColor;
      let btnBorderColor = theme.value.profile.btnBorderColor;
      if (bgColor === 'transparent') bgColor = '#000';
      // If border width is 0, use background color
      // This color most likely isn't shown to the user, so it could be any color
      if (theme.value.profile.btnBorderWidth === '0px') btnBorderColor = bgColor;
      return {
        height: wrapperHeight.value,
        overflow: wrapperOverflow.value,
        '--c-bg-color': tinycolor(bgColor).setAlpha(1).toString(),
        '--c-btn-height': btnHeight.value ? `${btnHeight.value}px` : '',
        '--c-border-color': btnBorderColor,
        '--c-border-width': theme.value.profile.btnBorderWidth === '0px' ? '1px' : theme.value.profile.btnBorderWidth
      };
    });
    const shadowSize = computed(() => {
      return +theme.value.profile.btnBoxShadowSize.replace('px', '');
    });
    function handleResize() {
      if (isOpen.value) {
        const btnOffsetHeight = activator.value.offsetHeight;
        const contentOffsetHeight = content.value.offsetHeight + 1;
        // Arrow height
        const arrowHeight = 12;
        wrapperHeight.value = `${contentOffsetHeight + btnOffsetHeight + arrowHeight + shadowSize.value * 2}px`;
        btnHeight.value = btnOffsetHeight;
      }
    }
    function handleTransitionEnd() {
      container.value.removeEventListener('transitionend', handleTransitionEnd);
      wrapperHeight.value = '';
      wrapperOverflow.value = '';
    }
    async function handleErrorAnimation() {
      container.value.classList.add('shake');
      await timeout(2000);
      container.value.classList.remove('shake');
    }
    watch(dimensions, handleResize);
    watch(isOpen, async newValue => {
      container.value.removeEventListener('transitionend', handleTransitionEnd);
      const btnOffsetHeight = activator.value.offsetHeight;
      btnHeight.value = btnOffsetHeight;
      wrapperOverflow.value = 'hidden';
      if (newValue) {
        wrapperHeight.value = `${btnOffsetHeight}px`;
        await nextTick();
        handleResize();
      } else wrapperHeight.value = `${btnOffsetHeight}px`;
      setTimeout(handleTransitionEnd, 500);
    });
    return {
      container,
      contentId,
      styles,
      activator,
      content,
      classes,
      handleResize,
      btnHeight,
      error: handleErrorAnimation
    };
  }
};
export { script as default };